// import React, { useEffect } from "react";
// import { Route, Redirect } from "react-router-dom";

// const ChangePasswordRoute = ({ component: Component, ...rest }) => {
//   const accessToken = localStorage.getItem("accessToken");
//   const otpVerified = localStorage.getItem("otpVerified") === "true";
//   const justLoggedIn = localStorage.getItem("justLoggedIn") === "true";
//   const tfaEnabled = localStorage.getItem("tfaEnabled") === "true"; // Check if TFA is enabled

//   // Block navigation when on the /changepassword page
//   useEffect(() => {
//     const preventNavigation = (e) => {
//       if (window.location.pathname !== "/changepassword") {
//         e.preventDefault();
//         window.history.pushState(null, null, "/changepassword"); // Force the user to stay on the same page
//       }
//     };

//     // Block the back and forward navigation
//     window.addEventListener("popstate", preventNavigation);
//     window.addEventListener("hashchange", preventNavigation);

//     // Block page reload and close (optional)
//     const handleBeforeUnload = (e) => {
//       const message = "You cannot leave the change password page. Please complete the process.";
//       e.returnValue = message;  // For most browsers
//       return message;  // For Chrome
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);

//     // Cleanup event listeners on unmount
//     return () => {
//       window.removeEventListener("popstate", preventNavigation);
//       window.removeEventListener("hashchange", preventNavigation);
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, []);

//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         // If no access token, redirect to login
//         if (!accessToken) {
//           console.log("aaa")
//           return <Redirect to="/login" />;
//         }

//         // If OTP is not verified and TFA is enabled, redirect to OTP page
//         if (!otpVerified && tfaEnabled) {
//           console.log("bbbb")

//           if (justLoggedIn) {
//           console.log("cccc")

//             return <Component {...props} />;
//           } else {
//           console.log("dddd")

//             return <Redirect to="/otp" />;
//           }
//         }

//         // If TFA is not enabled, skip OTP and go to change password directly
//         if (!tfaEnabled) {
//           console.log("eee")

//           return <Component {...props} />;
//         }

//         // If all conditions are satisfied, render the requested component
//         return <Component {...props} />;
//       }}
//     />
//   );
// };

// export default ChangePasswordRoute;
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ChangePasswordRoute = ({ component: Component, ...rest }) => {
  const otpVerified = localStorage.getItem("otpVerified");

  return (
    <Route
      {...rest}
      render={(props) =>
        otpVerified ? (
          <Component {...props} />
        ) : (
          <Redirect to="/otp" /> // Redirect to OTP page if OTP is not verified
        )
      }
    />
  );
};

export default ChangePasswordRoute;
